

export default function ReexecucaoMigration(){
    return (<>Reexecucao Migration</>)
} 